export const WINDOWS = 'windows';
